export default {

    judgeIdentity: null,
    assignedProjects: null,
    projectsWithSubmittedScores: null,
    currentProjectScore: null,
}